<template>
    <div class="grade-result">
      <div class="grade-top">
        <div class="top-left">
          <!-- <el-button type="primary" @click="handleOffer" :disabled="offerBtn?false:true">发起报价</el-button> -->
            <span v-has="'02010034'" v-if="bidData.syntheticalScore==='Y'" >
                <el-button type="primary" :disabled="pullBtn?false:true" @click="handlePull" :loading="loadPull">推送评分任务</el-button>
                </span>
        </div>
        <div class="top-right">
               <el-dropdown :hide-on-click="false" @command="handleCommand" v-has="'02010035'">
            <span class="el-dropdown-link">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="exportTechnical">导出技术分明细</el-dropdown-item>
               <el-dropdown-item :command="exportBusiness">导出商务分明细</el-dropdown-item>
              <el-dropdown-item :command="exportResultURl">导出评分结果</el-dropdown-item>
              <el-dropdown-item :command="exportExtraURl">导出附加分明细</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="grade-table">
          <el-tabs v-model="activeName">
    <el-tab-pane label="技术分" name="technical"><technicalPoints/></el-tab-pane>
    <el-tab-pane label="商务分" name="business"><businessPoints/></el-tab-pane>
    <el-tab-pane label="附加分" name="extra"><extraPoints/></el-tab-pane>
  </el-tabs>
      </div>
    </div>
</template>
<script>
import technicalPoints from './technicalPoints';
import businessPoints from './businessPoints';
import extraPoints from './extraPoints';
import { pullGrade, offerGrade } from '../../../api/gradeResult';
import { seachIspull } from '../../../api/bidScheme';
import { supplierType } from '../../../api/supplierBid.js';
import config from '@/config/user.env';
export default {
    components: { technicalPoints, businessPoints, extraPoints },
    data() {
        return {
            activeName: 'technical',
            loadPull: false,
            bidData: {},
            pullBtn: '',
            offerBtn: '',
            isPullGrade: '', // 是否已经推送评分
            tableData: [],
            // 供应商状态数据
            typeForm: {
                signUp: 0,
                money: 0,
                sucess: 0
            },
            iflowId: this.$route.query.mbpmFlowId,
            // 导出技术分明细
            exportTechnical: '/api-srm-web/bid/exportBidScoringDetail',
            // 导出商务分分明细
            exportBusiness: '/api-srm-web/bid/exportBidScoringDetail',
            // 导出评分结果
            exportResultURl: '/api-srm-web/bid/getBidScoreFinalScoreExport',
            // 导出附加分明细
            exportExtraURl: '/api-srm-web/bid/exportBidScoringDetail'

        };
    },
    mounted() {
        this.supType();
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        }
    },
    methods: {
        /** 导出 **/
        handleCommand(command) {
            let apiUrl = '';
            if (window.location.origin !== 'http://localhost.annto.com:8080') {
                apiUrl = config.apiUrl;
            }
            window.location = apiUrl + command;
        },
        // 发起报价
        async handleOffer() {
            const res = await offerGrade({ bidNo: this.$route.query.bidNo });
            if (res && res.code === '0') {
                this.$message({
                    message: '发起报价成功',
                    type: 'success'
                });
                this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                this.init();
            }
        },
        // 推送评分
        async handlePull() {
            this.$confirm(
                `报名供应商有${this.typeForm.signUp}个，投标成功${this.typeForm.sucess}个，已缴纳保证金但应标文件未盖章${this.typeForm.money}个，是否要推送评分任务?评分任务推送后，其他供应商不能再继续应标`,
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            )
                .then(async () => {
                    this.loadPull = true;
                    const res = await pullGrade({ bidNo: this.$route.query.bidNo });
                    this.loadPull = false;
                    if (res && res.code === '0') {
                        this.$message({
                            message: '推送评分任务成功',
                            type: 'success'
                        });
                        this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                        this.init();
                    }
                }).catch(() => {});
        },

        async init() {
            // 导出的接口加上招标编码
            this.exportTechnical = `/api-srm-web/bid/exportBidScoringDetail/${this.$route.query.bidNo}/1`;
            this.exportBusiness = `/api-srm-web/bid/exportBidScoringDetail/${this.$route.query.bidNo}/2`;
            this.exportResultURl = `/api-srm-web/bid/getBidScoreFinalScoreExport/${this.$route.query.bidNo}`;
            this.exportExtraURl = `/api-srm-web/bid/exportBidScoringDetail/${this.$route.query.bidNo}/4`;
            this.bidData = this.loginState;
            // 保证金截止时间
            const date = new Date(this.bidData.depositEndTime.replace(' ', 'T'));
            const time = date.getTime();
            // 获取的当前时间
            var timestamp = new Date().getTime();
            // 查看是否已经推送评分
            const graderes = await seachIspull(this.$route.query.bidNo);
            if (graderes && graderes.code === '0') {
                this.isPullGrade = graderes.data;
            }
            if (this.bidData.bidStatus === '30' && timestamp - time >= 0 && this.isPullGrade === 'N' && this.typeForm.sucess * 1 > 0) {
                this.pullBtn = true;
            } else {
                this.pullBtn = false;
            }
            if (this.bidData.syntheticalScore === 'Y' && this.isPullGrade === 'Y' && this.bidData.bidStatus === '43' && this.typeForm.sucess * 1 > 0) {
                this.offerBtn = true;
            } else if (this.bidData.syntheticalScore === 'N' && this.bidData.bidStatus === '30' && this.typeForm.sucess * 1 > 0) {
                this.offerBtn = true;
            } else {
                this.offerBtn = false;
            }
        },
        // 供应商应标状态请求数据
        async supType() {
            const res = await supplierType({ bidNo: this.$route.query.bidNo });
            if (res && res.code === '0') {
                this.typeForm.signUp = res.data.supplierCodeList.length;// 报名供应商
                this.typeForm.money = res.data.marginPay; // 已缴纳保证金但应标文件未盖章
                this.typeForm.sucess = res.data.bidSucceedNo;// 投标成功
            }
            this.init();
        }
    }
};
</script>
<style lang="less">
.grade-result {
  margin-top: 20px;
  .grade-top {
    display: flex;
    justify-content: space-between;
  }
  .top-right {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor:pointer;
       .el-dropdown-link{
        color:#00bcbf;font-size: 14px;margin-right:10px;
      }
  }
  .el-icon-upload2 {
    font-size: 15px;
    color: #00bcbf;
  }
  .load-info {
    font-size: 14px;
  }
  .marg {
    margin-right: 15px;
  }
  .grade-table {
    margin-top: 17px;
  }

}
</style>